import React, { useState } from "react";
import { Modal, Form, Input, Select, Upload, Button, Image, message, DatePicker, Col, Row, } from "antd";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { UploadOutlined } from "@ant-design/icons";
import callApi from "../../constants/API/CallApi";
import { uploadFileToS3 } from "../../helper/uploadImage";
import { ShowToast, Severty } from "../../helper/toast";
import { addEvent, getBelts, ListClasses, listExam, getBranches } from "../../constants/API/API";
import useApi from "../../hooks/useApi";
import moment from "moment";

const allowedImageTypes = ["image/png", "image/jpeg", "image/webp"];

const EventAdd = ({ visible, setVisible, refresh }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [description, setDescription] = useState("");
  const [file, setFile] = useState([]);
  const [gallery, setGallery] = useState([]);
  const [classes, setClasses] = useState([]);
  const [belts, setBelts] = useState([]);
  const [eventType, setEventType] = useState("Normal");
  const [exams, setExams] = useState([]);
  const [branches, setBranches] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState(null);

  useApi({
    callback: getBranches,
    dependencies: [refresh],
    shouldCallApi: true,
    onSuccess: ({ data }) => {
      const activeBranches = (data || []).filter((branch) => branch.isActive);
      setBranches(activeBranches);
    },
  });

  useApi({
    callback: ListClasses,
    payload: selectedBranch ? { branchId: selectedBranch } : null,
    dependencies: [selectedBranch],
    shouldCallApi: Boolean(selectedBranch),
    onSuccess: ({ list }) => {
      setClasses(list || []);
    },
    onError: (err) => {
      console.log("Error fetching class list", err);
      setClasses([]);
    },
  });

  useApi({
    callback: getBelts,
    payload: selectedBranch ? { branchId: selectedBranch } : null,
    dependencies: [selectedBranch],
    shouldCallApi: Boolean(selectedBranch),
    onSuccess: ({ data }) => {
      setBelts(data || []);
    },
    onError: (err) => {
      console.log("Error fetching belts", err);
      setBelts([]);
    },
  });

  useApi({
    callback: listExam,
    payload: {},
    dependencies: [],
    shouldCallApi: true,
    onSuccess: ({ data }) => {
      setExams(data);
    },
    onError: (err) => console.log("Error fetching exam list", err),
  });

  const handleCancel = () => {
    setVisible(false);
    form.resetFields();
    setDescription("");
    setFile([]);
    setEventType("Normal");
  };

  const handleGalleryChange = ({ fileList }) => {
    setGallery(
      fileList
        .filter(
          (f) =>
            f.status === "done" &&
            (f.url || (f.response && f.response.Location))
        )
        .map((f) => f.url || (f.response && f.response.Location))
    );
  };

  const beforeUpload = (file, type) => {
    const validTypes = allowedImageTypes;
    if (!validTypes.includes(file.type)) {
      message.error("Unsupported file type.");
      return Upload.LIST_IGNORE;
    }
    if (file.size / 1024 / 1024 > 100) {
      message.error("File must be smaller than 100MB.");
      return Upload.LIST_IGNORE;
    }
    return true;
  };

  const handleFileUpload = async (info) => {
    const { file } = info;
    setLoading(true);
    try {
      const data = await uploadFileToS3({
        file,
        dirName: "event",
      });
      const fileData = {
        uid: file.uid,
        name: file.name,
        status: "done",
        url: data.Location,
        thumbUrl: data.Location,
      };
      setFile([fileData]);
      form.setFieldsValue({
        media: data.Location//`${process.env.REACT_APP_AWS_S3_ENDPOINT}/${process.env.REACT_APP_AWS_S3_BUCKET_NAME}/` + data.Key,
      });
    } catch (error) {
      console.error(error);
      message.error("Upload failed.");
    } finally {
      setLoading(false);
    }
  };

  const handleOk = async (values) => {
    const payload = {
      ...values,
      description,
      media: file.length > 0 ? file[0].url : null,
      gallery,
    };

    if (!description?.trim()) {
      return message.error("Enter valid description.");
    } else {
      payload.description = description?.trimStart();
    }

    setLoading(true);
    callApi({
      callback: addEvent,
      payload,
      onSuccess: ({ message }) => {
        ShowToast(message, Severty.SUCCESS);
        form.resetFields();
        setDescription("");
        setFile([]);
        setVisible(false);
        refresh();
        setLoading(false);
      },
      onError: (err) => {
        ShowToast(err, Severty.ERROR);
        setLoading(false);
      },
    });
  };

  return (
    <Modal
      open={visible}
      width={800}
      centered
      className="tab_modal"
      title="Add Event"
      okText="Submit"
      onCancel={handleCancel}
      okButtonProps={{ form: "Form", htmlType: "submit", loading }}
    >
      <Form id="Form" form={form} onFinish={handleOk} layout="vertical">
        <Row gutter={12}>
          <Col span={24} md={12}>
            <Form.Item
              normalize={(val) => val?.trimStart()}
              name="title"
              label="Title"
              rules={[{ required: true, message: "Please enter title!" }]}
            >
              <Input placeholder="Enter title" />
            </Form.Item>
          </Col>
          <Col span={24} sm={24} md={12}>
            <Form.Item
              name="eventType"
              label="Event Type"
            // rules={[{ required: true, message: "Please select a belt!" }]}
            >
              <Select onChange={(val) => setEventType(val)} placeholder="Select Event Type">
                {["Normal", "Exam"]?.map((belt) => (
                  <Select.Option key={belt} value={belt}>
                    {belt}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>

          {eventType === "Exam" &&
            <Col span={24} sm={24} md={12}>
              <Form.Item
                name="examId"
                label="Select Exam"
                rules={[{ required: true, message: "Please select an exam!" }]}
              >
                <Select placeholder="Select Exam" allowClear showSearch optionFilterProp="children">
                  {exams?.map((exam) => {
                    const examName = exam?.name || exam?._id;
                    const beltName = Array.isArray(exam?.beltId)
                      ? exam.beltId.map((b) => b?.name || b).filter(Boolean).join(", ")
                      : (exam?.beltId?.name || "");
                    const examDate = exam?.date ? moment(exam.date).format("DD-MM-YYYY") : "";
                    const branchName = exam?.branchId?.name ? ` - ${exam.branchId.name}` : "";
                    const label = [examName, beltName].filter(Boolean).join(" - ") + (examDate ? ` (${examDate})` : "") + branchName;

                    return (
                      <Select.Option key={exam?._id} value={exam?._id}>
                        {label}
                      </Select.Option>
                    );
                  })}
                </Select>
              </Form.Item>
            </Col>

          }

          <Col span={24} md={12}>
            <Form.Item
              normalize={(val) => val?.trimStart()}
              name="address"
              label="Venue Address"
              rules={[{ required: true, message: "Please enter venue address!" }]}
            >
              <Input placeholder="Enter Venue Address" />
            </Form.Item>
          </Col>
          <Col span={24} md={12}>
            <Form.Item
              name="dateTime"
              label="Date & Time"
              rules={[
                { required: true, message: "Please select date and time" },
              ]}
            >
              <DatePicker
                showTime
                format="YYYY-MM-DD HH:mm"
                style={{ width: "100%" }}
                placeholder="Select Date & Time"
                disabledDate={(current) =>
                  current && current < moment().endOf("day")
                }
              />
            </Form.Item>
          </Col>
          <Col span={24} md={12}>
            <Form.Item
              name="capacity"
              label="Maximum Participants"
              rules={[
                {
                  required: true,
                  message: "Please enter max participants limit!",
                },
                {
                  validator: (_, value) => {
                    if (!value || value < 1) {
                      return Promise.reject(
                        new Error("Participants must be greater than 0")
                      );
                    }
                    return Promise.resolve();
                  },
                },
              ]}
            >
              <Input min={1} type="number" placeholder="Enter Maximum Participants" />
            </Form.Item>
          </Col>

          <Col span={24} md={12}>
            <Form.Item
              name="branchId"
              label="Branch"
              rules={[{ required: true, message: "Please select branch!" }]}
            >
              <Select
                placeholder="Select Branch"
                showSearch
                optionFilterProp="children"
                onChange={(branchId) => {
                  setSelectedBranch(branchId);
                }}
              >
                {branches?.map((branch) => (
                  <Select.Option key={branch?._id} value={branch?._id}>
                    {branch?.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>

          <Col span={24} sm={24} md={12}>
            <Form.Item
              name={["eligibility", "class"]}
              label="Class (Optional)"
            // rules={[{ required: true, message: "Please select a class!" }]}
            >
              <Select mode="multiple" placeholder="Select Class" showSearch optionFilterProp="children">
                {classes?.map((cls) => (
                  <Select.Option key={cls?._id} value={cls?._id}>
                    {cls?.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={24} sm={24} md={12}>
            <Form.Item
              name={["eligibility", "belt"]}
              label="Belt (Optional)"
            // rules={[{ required: true, message: "Please select a belt!" }]}
            >
              <Select mode="multiple" placeholder="Select Belt" showSearch optionFilterProp="children">
                {belts?.map((belt) => (
                  <Select.Option key={belt?._id} value={belt?._id}>
                    {belt?.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={24} md={12}>
            <Form.Item name="media" label="Upload Image (optional)">
              <Upload
                listType="picture"
                maxCount={1}
                beforeUpload={(file) => beforeUpload(file)}
                customRequest={(info) => handleFileUpload(info)}
                fileList={file}
                onRemove={() => {
                  setFile([]);
                }}
              >
                {file.length < 1 && (
                  <Button icon={<UploadOutlined />}>Upload Image</Button>
                )}
              </Upload>
              {file.length > 0 && (
                <div className="mt-2">
                  <Image width={100} src={file[0].url} />
                </div>
              )}
            </Form.Item>
          </Col>
          <Col span={24} md={12}>
            <Form.Item
              name="gallery"
              label="Gallery (Multiple Images)"
              valuePropName="fileList"
              getValueFromEvent={(e) => e?.fileList}
            >
              <Upload
                listType="picture"
                multiple
                customRequest={async ({ file, onSuccess }) => {
                  try {
                    const result = await uploadFileToS3({
                      file,
                      dirName: "dojo/eventGallery",
                    });
                    file.url = result.Location;
                    file.thumbUrl = result.Location;
                    onSuccess(file, file);
                  } catch (err) {
                    message.error("Failed to upload image");
                  }
                }}
                beforeUpload={beforeUpload}
                onChange={handleGalleryChange}
              >
                <Button icon={<UploadOutlined />}>Upload Gallery Images</Button>
              </Upload>
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              name="description"
              label="Description"
              normalize={(val) => val?.trimStart()}
              rules={[{ required: true, message: "Please enter description!" }]}
            >
              <ReactQuill
                theme="snow"
                value={description}
                onChange={setDescription}
                placeholder="Enter event description"
              />
            </Form.Item>
          </Col>
        </Row>

        {/* <Form.Item name="class" label="Class (Optional)">
          <Select placeholder="Select class" allowClear>
            {classList.map((cls) => (
              <Option key={cls._id} value={cls._id}>
                {cls.name}
              </Option>
            ))}
          </Select>
        </Form.Item> */}
      </Form>
    </Modal>
  );
};

export default EventAdd;
